

































































import { apiClient } from "@/services/api-client";
import { mapGetters } from "vuex";
import LoadingBlock from "@/components/LoadingBlock.vue";
import FavorietNewLijst from "@/components/FavorietNewLijst.vue";

export default {
  name: "FavorietToevoegen",
  components: { FavorietNewLijst, LoadingBlock },
  props: {
    buttonIsDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      favorieten: [],
      isNew: false,
      showModal: false,
      isInList: false
    };
  },
  computed: {
    ...mapGetters(["getUsername", "isAuthenticated"])
  },
  created() {
    this.CheckIfItemInList();
  },
  methods: {
    add(id) {
      apiClient
        .addItem({
          favorietLijstId: id,
          materieelSoort: this.$route.params.id
        })
        .then();
      this.$refs.modal.hide();
      this.isInList = true;
      this.$store.dispatch("snackbarAdded", {
        text: this.$t("FavorietToevoegen.voltooid"),
        type: "success"
      });
    },
    load() {
      this.isLoading = true;

      apiClient
        .getLijsten({
          accountNaam: this.getUsername,
          materieelSoort: this.$route.params.id
        })
        .then(response => {
          this.favorieten = response.lijsten;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    CheckIfItemInList(materieelSoort = this.$route.params.id) {
      apiClient
        .inlijst({
          accountNaam: this.getUsername,
          materieelSoort: materieelSoort
        })
        .then(response => {
          this.isInList = response.inList;
        });
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.CheckIfItemInList(to.params.id);
    next();
  }
};
